
import Vue, { VueConstructor } from "vue";
import KPaginatedAutocomplete from "@/components/crud/fields/KPaginatedAutocomplete.vue";
import { salesOrderStatusAutocomplete } from "@/modules/salesOrder/api/salesOrderStatus";

export default (
  Vue as VueConstructor<
    Vue & {
      $refs: {
        autocomplete: {
          refresh: () => Promise<unknown>;
        };
      };
    }
  >
).extend({
  name: "SalesOrderStatusAutocomplete",
  components: { KPaginatedAutocomplete },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
    value: {
      required: true,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    items: [],
  }),
  computed: {
    selectedAllOptions() {
      return this.items?.length === this.value?.length;
    },
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    clientId: {
      handler() {
        this.$refs.autocomplete.refresh();
      },
    },
  },
  async mounted() {
    const response = await this.salesOrderStatusAutocomplete({});
    this.items = response.data.data.map((item) =>
      this.returnObject ? item : item.id
    );
  },
  methods: {
    salesOrderStatusAutocomplete(data: any) {
      return salesOrderStatusAutocomplete(this.clientId, {
        ...data,
        perPage: 100,
      });
    },
    toggle() {
      this.$nextTick(() => {
        if (this.selectedAllOptions) {
          this.inputVal = [];
        } else {
          this.inputVal = this.items.slice();
        }
      });
    },
  },
});
